import type {
  LineItemDetails,
  LineItemFulfillmentHistory,
  OrderFulfillmentHistory,
} from '@vp/fulfillment-history';
import type { LineItemData } from '../types/OrderHistory.types';

/**
 * Maps order fulfillment history to a given line item.
 * @returns LineItemFulfillmentHistory | null The fulfillment history for the line item.
 * @param orderFulfillmentHistory
 * @param lineItemId
 * @returns LineItemFulfillmentHistory | null
 */
export const getLineItemFulfillmentHistory = (
  orderFulfillmentHistory: OrderFulfillmentHistory,
  lineItemId: string
): LineItemFulfillmentHistory | null => {
  const lineItemFulfillmentHistory = orderFulfillmentHistory?.lineItems?.find(
    (li) => li.lineItemId === lineItemId
  );
  return lineItemFulfillmentHistory || null;
};

// Maps internal LineItemData to the LineItemDetails type required by FulfillmentStatusBanner.
// We need this because our internal type has some optional fields that are required by FulfillmentStatusBanner.
// Long term we should align these types to avoid this mapping.
export const mapInternalItemDataToFulfillmentHistoryLineItemDetails = (
  item: LineItemData
): LineItemDetails => {
  const {
    attributes,
    documentUrl,
    id,
    livePreviewUrl,
    productKey,
    productName,
    productVersion,
    states,
  } = item;

  return {
    attributes: attributes.map((attr) => ({
      key: attr.key,
      keyDisplayName: attr.keyDisplayName || '',
      value: attr.value,
      valueDisplayName: attr.valueDisplayName || '',
    })),
    documentUrl: documentUrl || '',
    id: id || '',
    livePreviewUrl: livePreviewUrl || '',
    productKey: productKey || '',
    productName: productName || '',
    productVersion: productVersion || 0,
    states: states || [],
  };
};
